import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('Mandant ApiUrl');

export const MandantAuswahlRoute = new InjectionToken<string>('Mandant Auswahl Route');